import { v4 as uuidv4 } from 'uuid';

// Get or create a client ID
export const getClientId = (): string => {
  let clientId = localStorage.getItem('useless_client_id');
  
  if (!clientId) {
    clientId = uuidv4();
    localStorage.setItem('useless_client_id', clientId);
  }
  
  return clientId;
};